import styled from 'styled-components/native';

import WebContainer from 'components/WebContainer';

export default styled(WebContainer).attrs({ fullWidth: true })``;
